import React from "react";
import {
    DeliveryOrderHistoryEntry,
    DeliveryOrderPartHistoryEntry,
} from "../../../@types/DRO/DeliveryOrderResponse";
import { DeliveryOrderApi } from "../../../api/DeliveryOrder/DeliveryOrderApi";
import { HistoryColumn, OrderHistory } from "../OrderHistory/OrderHistory";

const orderColumns: HistoryColumn<DeliveryOrderHistoryEntry>[] = [
  { key: "status", label: "Status" },
  {
    key: "amount",
    label: "Amount",
    render: (row) => `₹ ${row.amount?.toFixed(2) ?? "0.00"}`,
  },
  { key: "referenceCode", label: "Reference Code" },
  { key: "orderDeadLineDate", label: "Order Deadline Date" },
  { key: "invoiceId", label: "Invoice Id" },
  { key: "action", label: "Action" },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

const partColumns: HistoryColumn<DeliveryOrderPartHistoryEntry>[] = [
  { key: "partName", label: "Part Name" },
  { key: "action", label: "Action" },
  { key: "quantityOrdered", label: "Qty Ordered" },
  { key: "quantityReceived", label: "Qty Received" },
  { key: "quantityReturned", label: "Qty Returned" },
  { key: "updatedBy", label: "Updated By" },
  { key: "updatedAt", label: "Updated At" },
];

interface Props {
  deliveryOrderId: number;
  variant?: "inline" | "dialog";
  open?: boolean;
  onClose?: () => void;
}

export const DeliveryOrderHistory: React.FC<Props> = ({
  deliveryOrderId,
  variant = "inline",
  open = false,
  onClose,
}) => (
  <OrderHistory
    title="Delivery Order History"
    variant={variant}
    open={open}
    onClose={onClose}
    orderColumns={orderColumns}
    partColumns={partColumns}
    fetchHistory={async () => {
      const res = await DeliveryOrderApi.api.getDeliveryOrderHistory(
        deliveryOrderId
      );
      return {
        orderHistory: res.data.deliveryOrderHistory,
        partHistory: res.data.partHistory,
      };
    }}
  />
);